import { GET_PAYMENT_HASHED_REQUESTED, GET_PAYMENT_METHOD_REQUESTED, GET_PAYMENT_VERIFY_REQUESTED } from "resources/actionTypes";

export function getPaymentVerify(userPaymentVerify) {
  const data = {
    userPaymentVerify: userPaymentVerify,
  };
  return {
    type: GET_PAYMENT_VERIFY_REQUESTED,
    payload: data,
  };
}

export function getPaymentHash(userPaymentHash,navigate){
  const data = {
    userPaymentHash:userPaymentHash,
    navigate:navigate,
  };
  return {
    type: GET_PAYMENT_HASHED_REQUESTED,
    payload: data,
  }
}

//Payment Method
export function getPaymentMethod(userPaymentMethod) {
  const data = {
    userPaymentMethod: userPaymentMethod,
  };
  return{
   type:GET_PAYMENT_METHOD_REQUESTED,
   payload:data
  }
  }